
import { defineComponent, PropType } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "certification-card",
  props: {
    certification: {
      type: Object as any,
      required: true
    },
    currentLanguage: {
      type: String,
      required: true
    }
  },
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  methods: {
    getStatusLabel(): string {
      // Reprovado com cooldown encerrado: pode tentar novamente
      if (this.certification.can_retry) {
        return this.$t(`${this.currentLanguage}.certification.list.available`);
      }
      if (this.certification.current_step && this.certification.current_step > 0) {
        // Verifica se foi aprovado
        if (this.certification.approved === 1) {
          return this.$t(`${this.currentLanguage}.certification.list.completed`);
        }
        console.log(this.certification);
        // Verifica se está no último step, approved é null e já enviou o user_report
        if (this.certification.awaiting_evaluation) {
          return this.$t(`${this.currentLanguage}.certification.list.awaiting_evaluation`);
        }
        return this.$t(`${this.currentLanguage}.certification.list.in_progress`);
      }
      return this.$t(`${this.currentLanguage}.certification.list.available`);
    },
    getStatusBadgeClass(): string {
      if (this.certification.can_retry) {
        return 'status-badge status-available';
      }
      if (this.certification.current_step && this.certification.current_step > 0) {
        // Verifica se foi aprovado
        if (this.certification.approved === 1) {
          return 'status-badge status-completed';
        }
        // Verifica se está no último step, approved é null e já enviou o user_report
        if (this.certification.awaiting_evaluation) {
          return 'status-badge status-awaiting-evaluation';
        }
        return 'status-badge status-in-progress';
      }
      return 'status-badge status-available';
    }
  }
});
